import {Action, ActionReducerMap} from '@ngrx/store';

import * as actionsUi from './qs-checks-controlling-home.actions.ui';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {Funktionsbereich, FunktionsbereichRollen, Pruefplan, Rolle, SaisonIdTypId, SaisonUebersicht, VeranstaltungMinimal} from '../../../../clients/qschecks';
import {
    GET_SAISON_UEBERSICHT, GET_SAISON_UEBERSICHT_ERFOLGREICH, GET_SAISON_UEBERSICHT_FEHLER,
    GetSaisonUebersichtErfolgreichAction
} from '../../../../client-ngrx/qschecks';
import {
    AKTUELLE_VERANSTALTUNG_QS_CONTROLLING_SETZEN,
    AktuelleVeranstaltungQsControllingSetzenAction, SaisonUebersichtLadenAction
} from './qs-checks-controlling-home.actions.ui';


export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    pruefplanId: string;
    saisonIdListe: Array<SaisonIdTypId>;
    prueferRolleIds: Array<string>;

    saisonUebersicht: SaisonUebersicht;
    saisonUebersichtLaden: boolean;
    saisonUebersichtFehler: boolean;

    aktuelleVeranstaltung: VeranstaltungMinimal;
}

export const initialPageState: PageState = {
    pruefplanId: '',
    saisonIdListe: [],
    prueferRolleIds: [],

    saisonUebersicht: null,
    saisonUebersichtLaden: false,
    saisonUebersichtFehler: false,

    aktuelleVeranstaltung: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {

    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, initialPageState, <PageState> {
                aktuelleVeranstaltung: state.aktuelleVeranstaltung,
                pruefplanId: state.pruefplanId,
                saisonIdListe: state.saisonIdListe,
                prueferRolleIds: state.prueferRolleIds,
                saisonUebersicht: state.saisonUebersicht
            });
        }

        case actionsUi.SAISON_UEBERSICHT_LADEN: {
            const a = <SaisonUebersichtLadenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanId: a.payload.pruefplanId,
                saisonIdListe: a.payload.saisonIds,
                prueferRolleIds: a.payload.rollenIds
            });
        }

        /* Saison-Übersicht */
        case GET_SAISON_UEBERSICHT: {
            return Object.assign({}, state, <PageState>{
                saisonUebersichtLaden: true,
                saisonUebersichtFehler: false
            });
        }

        case GET_SAISON_UEBERSICHT_ERFOLGREICH: {
            const a = <GetSaisonUebersichtErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                saisonUebersicht: a.payload,
                saisonUebersichtLaden: false,
                saisonUebersichtFehler: false,
            });
        }

        case GET_SAISON_UEBERSICHT_FEHLER: {
            return Object.assign({}, state, <PageState>{
                saisonUebersicht: null,
                saisonUebersichtLaden: false,
                saisonUebersichtFehler: true,
            });
        }

        case AKTUELLE_VERANSTALTUNG_QS_CONTROLLING_SETZEN: {
            const a = <AktuelleVeranstaltungQsControllingSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                aktuelleVeranstaltung: a.payload
            });
        }

        default: {
            return state;
        }
    }
}
